import { render, staticRenderFns } from "./LayoutWide.vue?vue&type=template&id=73da616e&scoped=true&"
import script from "./LayoutWide.vue?vue&type=script&lang=js&"
export * from "./LayoutWide.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWide.vue?vue&type=style&index=0&id=73da616e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da616e",
  null
  
)

export default component.exports